import { DestinationEvent } from '@eventbrite/event-renderer';
import {
    $FixMe,
    Nullable,
    SnakeCaseKeysToCamelCase,
} from '@eventbrite/ts-utils';
import { PriceType } from '../constants/prices';
import { SearchServerEnrolledExperiments } from './Experiments';

export interface PointRadius {
    latitude?: number;
    longitude?: number;
    radius?: string;
    offset?: string;
    scale?: string;
}

export interface SearchCriteriaShape {
    dates?: string[];
    price?: string;
    tags?: string;
}

export const SEARCH_FILTER_TYPE_PARAM = 'search_filter_type';
export enum SEARCH_FILTER_TYPE_VALUES {
    FILTER_PILLS = 'filter_pills',
    FILTER_PANEL = 'filter_panel',
    MARMALADE_FILTERS = 'marmalade_filters',
    MARMALADE_FILTERS_EXPANDED_HEADER = 'marmalade_filters_expanded_header',
}

export interface ApiSearchData {
    articles: {};
    current_user_id: string;
    profile_search: {};
    article_search: {};
    profiles: {};
    experiment_enrollment: SearchServerEnrolledExperiments;
    events: {
        pagination: {
            object_count: number;
            page_count: number;
            page_number: number;
            page_size: number;
            continuation: string;
        };
        // FIXME: These types are not accurate.
        // The API does not return DestinationEvent
        results: DestinationEvent[];
        aggs: Record<string, object>;
        promoted_results: DestinationEvent[];
        top_match: DestinationEvent[];
    };
    is_staff: boolean;
    search_id: string;
    es: [];
    event_search: ApiEventSearch;
}

export type EventSearch = SnakeCaseKeysToCamelCase<ApiEventSearch>;

export type ApiEventSearch = {
    dates?: any;
    tags?: any;
    price?: PriceType;
    q?: string;
    places?: string[];
    bbox?: string;
    currencies?: any;
    dedup?: boolean;
    date_range?: any;
    hash?: string;
    languages?: any;
    online_events_only?: boolean;
    organizations_or?: string[];
    page?: number;
    page_size?: number;
    search_id?: string;
    source?: any;
    special?: string[];
    point_radius?: $FixMe;
    include_promoted_events_for?: Nullable<boolean>;
    client_timezone?: $FixMe;
    duration_range?: $FixMe;
    aggs?: $FixMe;
};

export type PaginationData = {
    page: number;
    pageSize: number;
    pageCount: number;
    objectCount: number;
    continuation: string;
};

export type SearchState = {
    eventSearch: EventSearch;
    gaTrackingData: $FixMe[];
    searchId: string;
};
